import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  template: `
    <div class="unauthorized-container">
      <h2>Unauthorized</h2>
      <p>You do not have permission to access this page.</p>
      <button class="danger-btn" (click)="signOut()">
        <span class="menu-icon">🚪</span>
        <span class="menu-label">Logout</span>
      </button>
    </div>
  `,
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  constructor(private authService: AuthService) {}
  async signOut() {
    await this.authService.signOut();
  }
}
